import React, { useEffect } from 'react'

const ComingSoon = () => {
  useEffect(()=> {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  },[]);
  return (
    <>
    <div className='article-hero w-100' style={{ height: "100vh", overflow: 'hidden', width: '100vw' }}
        
            >
                <img src="/images/bg/coming-soon.png" alt="shoora coming soon"  style={{ objectFit: "cover", overflow: "hidden", width: '100vw', height: "100vh"
                 }} />
                
            </div>
    </>
  )
}

export default ComingSoon;